import { baseColors, baseFontFamily, dimensions } from "@Constants/baseStyles"
import { useAppUpdateHooks } from "../../Hooks/useAppUpdateHooks"
import React, { useEffect, useState } from "react"
import Modal from "react-native-modal"
import { Linking, View, Platform } from "react-native"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { RFValue } from "react-native-responsive-fontsize"
import { Spacer } from "@Components/Space"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Button } from "@Components/CustomButton/Button"
import Constants from "expo-constants"

const { appVersion } = Constants.expoConfig.extra

const NewUpdatePopup = () => {
    const { fetchLastAppUpdate, lastAppUpdate } = useAppUpdateHooks()
    const [isModalVisible, setModalVisible] = useState(false)

    useEffect(() => {
        fetchLastAppUpdate()
    }, [])

    useEffect(() => {
        const versionFromJson = isNaN(Number(lastAppUpdate?.version)) ? 0 : Number(lastAppUpdate?.version)
        const versionFromEnv = Number(appVersion)
        if (versionFromJson > versionFromEnv) {
            setModalVisible(true)
        }
    }, [lastAppUpdate])

    const handleOpenUrl = () => {
        const updateUrlLink = Platform.OS === "android" ? lastAppUpdate.url_android : lastAppUpdate.url_ios
        Linking.canOpenURL(updateUrlLink).then((supported) => {
            if (supported) {
                Linking.openURL(updateUrlLink)
            } else {
                console.log("Don't know how to open URI: " + updateUrlLink)
            }
        })
    }

    return (
        <Modal
            isVisible={isModalVisible}
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            style={{
                justifyContent: "flex-end",
                margin: 0
            }}
        >
            <View
                style={{
                    height: dimensions.fullHeight / 2.8,
                    backgroundColor: "white",
                    backgroundColor: "#fff",
                    paddingHorizontal: 20,
                    paddingVertical: 25,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10
                }}
            >
                <BreeSerifText
                    fontSize={RFValue(16)}
                    style={{
                        textAlign: "center",
                        marginVertical: 10,
                        color: baseColors.green.primary
                    }}
                >
                    Mise à jour disponible
                </BreeSerifText>

                <Spacer />

                <OpenSansText>{lastAppUpdate?.text ?? ""}</OpenSansText>

                <Spacer />

                <Button
                    onPress={handleOpenUrl}
                    text="Télécharger la nouvelle version"
                    width="100%"
                    height={45}
                    backgroundColor={baseColors.green.primary}
                    labelColor="white"
                />

                <Spacer />
            </View>
        </Modal>
    )
}

export default NewUpdatePopup
